import React from 'react';
import styles from './DebugHttpFailure.module.scss';
import { Button } from '../Button/Button';

export type DebugHttpFailureProps =
  | (
      | {
          message?: string;
        }
      | { error: Error }
    ) & { reset?: () => void };

export function DebugHttpFailure(props: DebugHttpFailureProps) {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  let message: string;
  if ('message' in props) {
    message = JSON.stringify(props.message, null, 2);
  } else if ('error' in props) {
    message = JSON.stringify(props.error.message, null, 2);
  } else {
    message = '[No message was supplied]';
  }

  return (
    <div>
      <pre className={styles.messageArea}>{message}</pre>
      {props.reset && (
        <Button xsmall primary onClick={props.reset}>
          Retry request
        </Button>
      )}
    </div>
  );
}
